@import 'styles/mixins';
@import 'styles/blaze/mixins';
@import 'styles/variables';

.root {
  display: flex;
  flex-direction: column;
  gap: 2px;
  background: var(--default-bg);
  min-height: 100vh;

  @include for-phone-only {
    background: var(--light-100);
  }
}

.content {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  border-radius: 6px;
  background: var(--light-40);

  /* Container Shadow */
  box-shadow: 1px 1px 0px 0px rgba(255, 255, 255, 0.9) inset, 0px 2px 12px 0px rgba(0, 0, 0, 0.04);
  @include blur(35px);
}

.tabTitle {
  display: flex;
  gap: 6px;
  width: 100%;
  justify-content: center;
}

.metricsGroup {
  display: flex;
  gap: 15px;

  @media (max-width: $largeDevicesMinWidth) {
    flex-direction: column;
    gap: 10px;
  }
}

.extra {
  display: flex;
  align-items: center;
  gap: 6px;
}
